import React, { useState, useEffect, useReducer } from "react";
import Dropdown from "./Dropdown";
import Searchbar from "./Searchbar";
import Button from "./Button";
import Container from "./Container";
import Table1 from "./Table1";
import NewClient from "./NewClient";
import EditText from "./EditText";
import API_URLS from "../Urls";
import { reducer, initialState } from '../reducers/reducers';

const SearchClient = ({ onDeselected, onSelected }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [client, setClient] = useState(null);
  const [searchOption, setSearchOption] = useState('id');
  const [isSearchMode, setIsSearchMode] = useState(false);

  const [searchData, setSearchData] = useState('');
  const [selected, setSelected] = useState(false);
  const [fetchedClients, setFetchedClients] = useState([]);

  // Paginación
  const [page, setPage] = useState(1);
  const [perPage] = useState(10);
  const [lastPage, setLastPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  // Actualiza paginación al cambiar fetchedClients
  useEffect(() => {
    setTotalItems(fetchedClients.length);
    setLastPage(Math.ceil(fetchedClients.length / perPage) || 1);
    setPage(1);
  }, [fetchedClients, perPage]);

  // Obtiene lista completa de clientes al montar
  const fetchClients = () => {
    setIsSearchMode(false);
    fetch(API_URLS.CLIENTS, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    })
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok ' + response.statusText);
        return response.json();
      })
      .then(data => {console.log(data);setFetchedClients(data)})
      .catch(error => console.error('Fetch error:', error));
  };

  // Busca clientes según criterios
  const searchClients = () => {
    setIsSearchMode(true);
    
    fetch(`${API_URLS.CLIENTS}?${searchOption.toLowerCase()}=${searchData}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    })
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok ' + response.statusText);
        return response.json();
      })
      .then(data => {console.log(data);setFetchedClients(data)})
      .catch(error => console.error('Fetch error:', error));
  };

  useEffect(() => { fetchClients(); }, []);

  const paginatedClients = fetchedClients.slice((page - 1) * perPage, page * perPage);

  // Controles de paginación
  function PaginationControls() {
    const buttonStyle = {
      backgroundColor: '#7AACE3', color: 'white', border: 'none', borderRadius: '4px',
      padding: '8px 16px', margin: '0 5px', cursor: 'pointer', fontWeight: 'bold', transition: 'background-color 0.3s'
    };
    const disabledStyle = { ...buttonStyle, backgroundColor: '#cccccc', cursor: 'not-allowed', opacity: 0.7 };
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '15px 0' }}>
        <button onClick={() => setPage(p => Math.max(p - 1, 1))} disabled={page === 1} style={page === 1 ? disabledStyle : buttonStyle}>
          &lt; Anterior
        </button>
        <span style={{ margin: '0 15px', fontWeight: 'bold' }}>
          Página {page} de {lastPage} ({totalItems} registros)
        </span>
        <button onClick={() => setPage(p => Math.min(p + 1, lastPage))} disabled={page === lastPage} style={page === lastPage ? disabledStyle : buttonStyle}>
          Siguiente &gt;
        </button>
      </div>
    );
  }

  // Renderizado condicional según selección
  const renderClientSection = () => {
    if (selected && client) {
      return (
        <Table1
          optdeselect
          onClickDeselect={() => { setSelected(false); setClient(null); onDeselected(); }}
          headers={['id', 'Nombre', 'Apellidos', 'Correo', 'Telefono']}
          data={[client]}
        />
      );
    }

    return (
      <div>
        <div className="header1">Buscar cliente</div>
        
          <Container>
            <div>Buscar por:</div>
            <Dropdown
              options={['Id', 'Nombre', 'Telefono']}
              returnSelectedOption={setSearchOption}
            />
            <EditText text="Buscar" onChange={(data)=>setSearchData(data)} />
            <Button text="Buscar" color="#61BAA5" onClick={() =>searchClients()} />
            <Button text="Añadir Cliente" color="#7AACE3" onAccept={() => {
  dispatch({ type: 'closeNewClient' });
  if (isSearchMode) {
    searchClients(); // refresh with search filter applied
  } else {
    fetchClients();  // refresh full list
  }
}}
 onClick={() => dispatch({ type: 'openNewClient' })} />
          </Container>
        

        <PaginationControls />
        <Table1
          optselect
          headers={['id', 'Nombre', 'Apellidos', 'Correo', 'Telefono']}
          onClickSelect={data => { onSelected(data); setSelected(true); setClient(data); }}
          data={paginatedClients.map(item => ({
            id: item.id,
            nombre: item.nombre,
            apellidos: item.apellidos,
            correo: item.correo,
            telefono: item.telefono
          }))}
        />
        <PaginationControls />

        {state.statusNewClient && (
          <NewClient
            onAccept={() => { dispatch({ type: 'closeNewClient' }); fetchClients(); }}
            onClose={() => dispatch({ type: 'closeNewClient' })}
          />
        )}
      </div>
    );
  };

  return (
    <div>
      {renderClientSection()}
    </div>
  );
};

export default SearchClient;
